// FullCirkl brand palette
export const BRAND = {
  sage:       "#8A9778",
  sageDark:   "#6B7760",
  sageLight:  "#A8B29A",
  gold:       "#D4A45A",
  goldDark:   "#B8893F",
  goldLight:  "#E8C48A",
  cream:      "#F8F5F0",
  creamDark:  "#EDE8DF",
};

/** Logo-matched icon background gradients — use on every dashboard page */
export const ICON_BG = {
  primary: "icon-brand",
  alt:     "icon-brand-alt",
  soft:    "icon-brand-soft",
  gold:    "icon-brand-gold",
};

export const ICON_BG_CYCLE = [
  ICON_BG.primary,
  ICON_BG.alt,
  ICON_BG.gold,
  ICON_BG.soft,
];

export { default as logoSrc } from "../assets/images/logo.png";
